import script from "./StickersUpsellQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./StickersUpsellQuantity.vue?vue&type=script&setup=true&lang=js"

import "./StickersUpsellQuantity.vue?vue&type=style&index=0&id=645a7e03&lang=scss"

const __exports__ = script;

export default __exports__